import {
    green600,
    orange600,
    red600,
    yellow600,
    white,
    grey900
} from "material-ui/styles/colors";

export const reportStates = ["new", "in_treatment", "treated", "refused"];
export const stateColors = [yellow600, orange600, green600, red600];
export const stateTextColors = [grey900, grey900, white, grey900];



// WEBPACK FOOTER //
// src/constants/reports.js